module.exports = "/shifts/shift-swap/user-search-bar-a6f5ab.html";